// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".block-enter {\n  opacity: 0;\n}\n.block-enter-active {\n  opacity: 1;\n  transition: opacity 200ms;\n}\n.block-exit {\n  opacity: 1;\n}\n.block-exit-active {\n  opacity: 0;\n  transition: opacity 200ms;\n}\n", ""]);
// Exports
module.exports = exports;
